import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'mobile-holdings-dialog',
    templateUrl: 'holdings-dialog.component.html'
})
export class HoldingsMobileDialog {

    constructor(
        public dialogRef: MatDialogRef<HoldingsMobileDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    onNoClick(): void {
        this.dialogRef.close();
    }

}
